import axios from 'axios'

import { createCollection } from './collection'

const DESTROY = 'DESTROY'

const API_URL = process.env.API_URL

const collection = createCollection({
  fetchAll: {
    // request: () => axios.get('/static/mock-data/users.json'),
    request: () => axios.get(API_URL + '/users'),
    processResponse (response) {
      const ids = []
      const entities = {}
      for (let user of response.data.data) {
        if (entities[user.user_id]) {
          console.warn('Duplicate entry in response data', entities[user.user_id], parseUser(user))
        } else {
          ids.push(user.user_id)
          entities[user.user_id] = parseUser(user)
        }
      }
      return { ids, entities, loaded: true }
    }
  }
})

Object.assign(collection.actions, {
  destroy: ({commit, state}) => {
    return new Promise((resolve, reject) => {
      const user = state.entities[state.selectedEntityId]
      if (user && user.email) {
        axios.delete(API_URL + '/auth/deleteuser', {
          params: {
            email: user.email
          }
        }).then(response => {
          commit(DESTROY)
          resolve()
        }, error => {
          reject(error)
        })
      } else {
        reject()
      }
    })
  }
})

Object.assign(collection.mutations, {
  [DESTROY]: (state) => {
    const id = state.selectedEntityId
    delete state.entities[id]
    state.ids.splice(state.ids.indexOf(id), 1)
    state.selectedEntityId = state.ids[0]
  }
})

function parseUser (data) {
  let user = {
    id: data.user_id,
    registration_time: Number(data.reg_time),
    user_name: data.user_name,
    email: data.email,
    status: data.status,
    language: data.language || '',
    permissions: {}
  }
  return user
}

export default collection



// WEBPACK FOOTER //
// ./src/store/modules/users.js